import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './components/Login';
import SetupAdmin from './components/SetupAdmin';
import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import AdminDashboard from './components/AdminDashboard';
import ManagerDashboard from './components/ManagerDashboard';
import LogFormRouter from './components/LogFormRouter';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/setup" element={<SetupAdmin />} />
            <Route path="/log/:homeId" element={<LogFormRouter />} />
            
            <Route
              path="/admin/dashboard"
              element={
                <PrivateRoute adminOnly>
                  <Navbar />
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/manager/dashboard"
              element={
                <PrivateRoute>
                  <Navbar />
                  <ManagerDashboard />
                </PrivateRoute>
              }
            />

            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
